export const RECTIFICATIONS = "rectifications";
export const DEFECTS = "defects";
export const SUBGRADES = "subgrades";
export const GRADE = "grade";